// LAP-550 — Card Matières premières : header + grid 2 colonnes + actualités
import { Box, Grid } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Delta from '../../_shared/Delta'
import CardHeader from '../../_shared/CardHeader'
import { invTheme } from '../../_shared/theme'
import AddOpportunityAction from '../../_shared/AddOpportunityAction'

export default function CommoditiesCard({ result = {} }) {
  const { t } = useTranslation('layout')
  return (
    <Box display="flex" flexDirection="column" height="100%">
      <CardHeader
        icon="/images/Commodities.png"
        title={t('investments.markeet.commodities.title')}
        subtitle={t('investments.markeet.commodities.subtitle')}
      />
      <Box mt={2} height="100%" sx={{ overflow: 'hidden' }}>
        <Grid container spacing={1.5}>
          {result?.commodity_market?.map((item, index) => {
            const up = item.variantion_1_jour >= 0
            return (
              <Grid item sm={6} key={index}>
                <Box
                  sx={{
                    p: 1,
                    borderRadius: 1.5,
                    backgroundColor: 'rgba(255,255,255,0.03)',
                    border: '1px solid rgba(255,255,255,0.05)',
                    position: 'relative',
                    pl: 1.5,
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      left: 0,
                      top: 8,
                      bottom: 8,
                      width: 2,
                      backgroundColor: up ? invTheme.positive : invTheme.negative,
                      borderRadius: 2,
                    },
                  }}
                >
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box sx={{ fontSize: 13, color: 'rgba(255,255,255,0.7)' }}>{item.name}</Box>
                    <AddOpportunityAction
                      initialValues={{
                        name: item.name,
                        price: item.price,
                        market_id: (item.symbol || '').slice(0, 5),
                        value_change_pct: item.variantion_1_jour,
                      }}
                    />
                  </Box>
                  <Box display="flex" alignItems="center" mt={0.5}>
                    <Box sx={{ fontWeight: 600 }}>
                      {parseFloat(item.price).toFixed(2)}
                      <Box component="span" sx={{ fontSize: 11, ml: 0.5, color: 'rgba(255,255,255,0.5)' }}>
                        {item.symbol}
                      </Box>
                    </Box>
                    <Box sx={{ ml: 'auto' }}>
                      <Delta value={item.variantion_1_jour} unit="%" />
                    </Box>
                  </Box>
                </Box>
              </Grid>
            )
          })}
        </Grid>
        <Box mt={2.5}>
          <Box
            sx={{
              ...invTheme.subtitle,
              borderTop: '1px dashed rgba(255,255,255,0.08)',
              pt: 1.5,
            }}
          >
            {t('investments.markeet.commodities.news')}
          </Box>
          {result?.news?.map((item, index) => (
            <Box key={index} mt={1}>
              <Box display="flex" sx={{ fontSize: 13, lineHeight: 1.35 }}>
                <Box sx={{ flexGrow: 1 }}>{item.title}</Box>
                <Box component="span" ml={1} sx={{ color: 'rgba(255,255,255,0.45)', fontSize: 11, whiteSpace: 'nowrap' }}>
                  {moment(item.published_at).fromNow()}
                </Box>
              </Box>
              <Box sx={{ color: 'rgba(255,255,255,0.4)', fontSize: 10, mt: 0.25 }}>{item.source}</Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  )
}
